export default __webpack_public_path__ + "static/media/seller-title.a971c222.svg";